import React from 'react';
import ComboBox from '../Form/ComboBox';
import QuoteHistoryActions from '../../Actions/QuoteHistoryActions';
import QuoteHistorySymbolsActions from '../../Actions/QuoteHistorySymbolsActions';
import QuoteHistoryStore from '../../Stores/QuoteHistoryStore';
import QuoteHistorySymbolsStore from '../../Stores/QuoteHistorySymbolsStore';

const HistorySymbol = React.createClass({
  displayName: 'HistorySymbol',

  getInitialState: function () {
    return {
      historyId: this.props.value === Constants.Diff ? Constants.Diff : 0,
      haveDiff: this.props.value === Constants.Diff
    };
  },

  getDefaultProps: function () {
    return {
      disabled: false,
      name: '',
      value: 0
    };
  },

  propTypes: {
    name: React.PropTypes.string.isRequired,
    disabled: React.PropTypes.bool
  },

  componentDidMount: function () {
    QuoteHistoryStore.addChangeListener(this.onChangeStore);
    QuoteHistorySymbolsStore.addChangeListener(this.onChangeStore);
    QuoteHistoryActions.update();
    QuoteHistorySymbolsActions.update();
  },
  componentWillUnmount: function () {
    QuoteHistoryStore.removeChangeListener(this.onChangeStore);
    QuoteHistorySymbolsStore.removeChangeListener(this.onChangeStore);
  },

  onChangeStore: function () {
    let histSymbol = QuoteHistorySymbolsStore.get(this.props.value);
    let historyId = this.state.historyId;
    if (histSymbol) {
      historyId = histSymbol.HistoryId;
    }

    this.setState({historyId: historyId});
  },

  onChangeHistory: function (name, value) {
    let intValue = value === Constants.Diff ? value : parseInt(value);
    this.setState({historyId: intValue});
  },

  onChange: function (name, value) {
    let intValue = value === Constants.Diff ? value : parseInt(value);
    this.props.onChange && this.props.onChange(this.props.name, intValue);
  },

  getHistoryOptions: function () {
    let options = QuoteHistoryStore.getForSelect();

    if (this.state.haveDiff) {
      options.push({value: Constants.Diff, label: Constants.Diff})
    }

    return options;
  },

  getSymbolOptions: function () {
    let symbols = QuoteHistorySymbolsStore.getSymbols(this.state.historyId);

    // show parent symbols, but use real Id for current value
    let options = symbols.map(sym => ({value: sym.Id, label: sym.Name + "(" + sym.Id + ")"}));

    if (this.state.haveDiff) {
      options.push({value: Constants.Diff, label: Constants.Diff})
    }

    return options;
  },

  getParentSymbolId: function (id) {
    if (id === Constants.Diff) {
      return id;
    }

    let sym = QuoteHistorySymbolsStore.get(id);
    if (sym && sym.ParentId !== 0) {
      return this.getParentSymbolId(sym.ParentId);
    }

    return id;
  },

  render: function () {

    return (<div>
      <ComboBox name="historyId"
                grid={1 / 2}
                sorted={true}
                value={this.state.historyId}
                options={this.getHistoryOptions()}
                onChange={this.onChangeHistory}
                disabled={this.props.disabled}
      />
      <ComboBox name={this.props.name}
                grid={1 / 2}
                sorted={true}
                value={this.getParentSymbolId(this.props.value)}
                options={this.getSymbolOptions()}
                onChange={this.onChange}
                disabled={this.props.disabled}
      />
    </div>);
  }
});

export default HistorySymbol;



// WEBPACK FOOTER //
// ./src/js/Component/Form/HistorySymbol.jsx